import type React from 'react';

import { ComboBox, ComboBoxItem } from '@change/ds-forms';

import type { GeoScope, Place } from '../../shared/types';
import { usePlaceField } from '../hooks/usePlaceField';

export type PlaceFieldProps = {
	label: string;
	placeholder?: string;
	labelIsVisible?: boolean;
	geoScope?: GeoScope;
	defaultPlaceValue?: Place | null;
	onSelect?: (place: Place | null) => void;
	error?: string | null;
};

const PlaceFieldComponent: React.FC<PlaceFieldProps> = ({
	geoScope,
	defaultPlaceValue = null,
	label,
	placeholder,
	labelIsVisible = true,
	onSelect,
	error,
}) => {
	const { placeInputValue, onPlaceInputChange, onPlaceFocus, onPlaceBlur, onPlaceChange, placePredictions } =
		usePlaceField({
			geoScope,
			defaultPlaceValue,
			onSelect,
		});

	return (
		<ComboBox<Place>
			id="petition-place"
			name="petition-place"
			label={label}
			labelIsVisible={labelIsVisible}
			placeholder={placeholder}
			size="large"
			menuTrigger="input"
			allowsEmptyCollection
			showCaretDownIcon={false}
			inputValue={placeInputValue}
			onInputChange={onPlaceInputChange}
			onFocus={onPlaceFocus}
			onBlur={onPlaceBlur}
			onSelectionChange={(key) => {
				const place = placePredictions.find((p) => p.googlePlacesId === String(key));
				onPlaceChange(place ?? null);
			}}
			items={placePredictions}
			isInvalid={Boolean(error)}
			errorMessage={error ?? undefined}
			data-qa="petition-place"
		>
			{(place) => <ComboBoxItem id={place.googlePlacesId} label={place.displayName} />}
		</ComboBox>
	);
};

export const PlaceField = PlaceFieldComponent;
